
import sanityClient from './sanityClient'
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from './pages/homepage/component/footer';
import Navbar from './components/navbar';


const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "post"] | order(_createdAt desc) {
        _id,
        title,
        slug,
        publishedAt,
        mainImage {
          asset-> {
            url
          }
        },
        label,
        readTime
      }`)
      .then((data) => {
        setBlogs(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching all blogs:", error);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <Navbar />
      <div className="px-6 pt-16 pb-28 md:pt-28 md:pb-48 md:px-20">
      <h1 className="text-3xl font-bold mb-8 text-center">All Blog Posts</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {loading ? (
          <p>Loading...</p>
        ) : (
          blogs.map((blog) => (
            <div key={blog._id} className="bg-white rounded-lg shadow p-4">
              <img
                src={blog.mainImage.asset.url}
                alt={blog.title}
                className="w-full h-[200px] object-cover rounded"
              />
              <p className="mt-4 text-xs text-gray-500">
                  { blog.publishedAt && new Date(blog.publishedAt).toDateString()} • {blog?.readTime || "5 min read"}
              </p>
              <h2 className="mt-2 text-lg font-semibold line-clamp-1">{blog.title}</h2>
              <div className="flex items-center gap-1 md:gap-2 py-2 md:py-4">
                    <Link to={`/blog/${blog.slug.current}`}>
                      <p className="text-[#32AE4C] text-xs md:text-lg lg:text-sm">
                        Read More
                      </p>
                    </Link>
                    <img src={'/assets/arrow.svg'} alt="arrow-img" />
                  </div>
             
            </div>
          ))
        )}
      </div>
    </div>
    <Footer />
    </div>
  );
};

export default BlogList;
